import React, {Component} from 'react';
import Header from './components/Header/index';
import NumberForm from './components/NumberForm/index.js';
// import Unavailable from './components/unavailable/Unavailable.js';
import {Route} from 'react-router-dom';
import Banner from './components/Banner/index.jsx';

class App extends Component {
    render() {
        return (
            <div className="app">
                <Header/>
                <Banner />
                <Route exact path="/" component={NumberForm}/>
            </div>
        );
    }
}

export default App;
